import { useNavigate, useLocation } from "react-router"
import { getAuth } from "../modules/auth"
import { pageRoutes } from "./dictionary"
import { useState, useEffect } from "react"
import { setTestScoreStrategyModal } from "./Auth/setPrompts"
import { AuthReactGAHandlers } from "./ReactGAHandlers"
import instagram from '../../custom_assets/social/instagram.png'
import facebook from '../../custom_assets/social/facebook.png'
import x from '../../custom_assets/social/x.png'
import youtube from '../../custom_assets/social/youtube.png'
import tiktok from '../../custom_assets/social/tiktok.png'
import { Fragment } from "react"


const Footer = ({ setPrompt, setNavigateTo }) => {

  const { handleGAEventSignInModalOpen } = AuthReactGAHandlers()

  let location = useLocation()
  let apiToken: any = undefined

  if (getAuth()?.api_token && getAuth()?.groups) {
    apiToken = getAuth()?.api_token
  }

  let navigate = useNavigate()

  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

  useEffect(() => {
    const updateScreenSize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);

  const toolsResourcesOne = <div id="dca-footer-column-wrapper">
    <div className="dca-footer-group-title">Tools & Resources</div>
    <div className="dca-footer-link-column">
      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.dashboard)
        }}
      >DASHBOARD</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.overviewIntroduction)
        }}
      >INTRODUCTION & ADVICE</div>

      <div className="dca-footer-link">COLLEGES</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.collegeSearch)
        }}>-&nbsp;&nbsp;EXPLORER</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.collegeDataVisualization)
        }}
      >-&nbsp;&nbsp;SCATTERGRAMS</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.premiumSpecializedRankings)
        }}
      >-&nbsp;&nbsp;Specialized Rankings</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.premiumRDSpend)
        }}
      >-&nbsp;&nbsp;R&D Spend</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.premiumCrimeSafety)
        }}
      >-&nbsp;&nbsp;Crime & Safety</div>
    </div>
  </div>

  const toolsResourcesTwo = <div id="dca-footer-tools-resources-wrapper">
    <div className="dca-footer-group-title">Tools & Resources</div>
    <div className="dca-footer-link-column">
      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.majorSearch)
        }}
      >Majors Explorer</div>

      <div className="dca-footer-link"
      >Extracurriculars</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.ecSearch)
        }}
      >-&nbsp;&nbsp;Explorer</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.ecPremiumInsightsBase)
        }}
      >-&nbsp;&nbsp;EC Insights</div>

      {(apiToken != undefined) ? <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.testScoreStrategy)
        }}
      >Test Score Guidance</div> : <a
        className="dca-footer-link"
        style={{ color: 'black' }}
        data-bs-toggle={"modal"}
        href={"#login_modal"}
        onClick={() => {
          setTestScoreStrategyModal(apiToken, navigate, setPrompt, setNavigateTo);
          apiToken == undefined && handleGAEventSignInModalOpen('forced')
        }}
      >Test Score Guidance</a>}

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.advisorNetwork)
        }}
      >Advisors Network</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.personalizedExpertHelp)
        }}
      >Expert Help</div>
    </div>
  </div>

  const toolsResourcesMobile = <div id="dca-footer-column-wrapper">
    <div className="dca-footer-group-title">Tools & Resources</div>
    <div className="dca-footer-link-column">
      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.dashboard)
        }}
      >DASHBOARD</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.overviewIntroduction)
        }}
      >INTRODUCTION & ADVICE</div>

      <div className="dca-footer-link">COLLEGES</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.collegeSearch)
        }}>-&nbsp;&nbsp;EXPLORER</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.collegeDataVisualization)
        }}
      >-&nbsp;&nbsp;SCATTERGRAMS</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.premiumSpecializedRankings)
        }}
      >-&nbsp;&nbsp;Specialized Rankings</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.premiumRDSpend)
        }}
      >-&nbsp;&nbsp;R&D Spend</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.premiumCrimeSafety)
        }}
      >-&nbsp;&nbsp;Crime & Safety</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.majorSearch)
        }}
      >Majors Explorer</div>

      <div className="dca-footer-link"
      >Extracurriculars</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.ecSearch)
        }}
      >-&nbsp;&nbsp;Explorer</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.ecPremiumInsightsBase)
        }}
      >-&nbsp;&nbsp;EC Insights</div>

      {(apiToken != undefined) ? <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.testScoreStrategy)
        }}
      >Test Score Guidance</div> : <a
        className="dca-footer-link"
        style={{ color: 'black' }}
        data-bs-toggle={"modal"}
        href={"#login_modal"}
        onClick={() => {
          setTestScoreStrategyModal(apiToken, navigate, setPrompt, setNavigateTo);
          apiToken == undefined && handleGAEventSignInModalOpen('forced')
        }}
      >Test Score Guidance</a>}

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.advisorNetwork)
        }}
      >Advisors Network</div>

      <div
        className="dca-footer-link"
        onClick={() => {
          navigate(pageRoutes.personalizedExpertHelp)
        }}
      >Expert Help</div>
    </div>
  </div>

  const company = <div id="dca-footer-company-wrapper">
    <div className="dca-footer-group-title">Company</div>
    <div className="dca-footer-company-links">
      <div className="d-flex flex-column">
        <div
          className="dca-footer-link"
          onClick={() => {
            navigate(pageRoutes.about)
          }}
        >About</div>

        <a
          className="dca-footer-link"
          href={pageRoutes.blog}
        >Blog</a>

        <div
          className="dca-footer-link"
          onClick={() => {
            navigate(pageRoutes.faq)
          }}
        >FAQ</div>

        <div
          className="dca-footer-link"
          onClick={() => {
            navigate(pageRoutes.contact)
          }}
        >Contact</div>

        <div
          className="dca-footer-link"
          style={{ whiteSpace: 'nowrap' }}
          onClick={() => {
            navigate(pageRoutes.privacyPolicy)
          }}
        >Privacy Policy</div>

        <div
          className="dca-footer-link"
          onClick={() => {
            navigate(pageRoutes.termsOfService)
          }}
        >Terms</div>
      </div>
    </div>
  </div>

  let socialsList = [
    {
      icon: instagram,
      alt: `instagram`,
      size: isMobile ? '20px' : '25px',
      url: `https://www.instagram.com/nextfour_ai/`
    },
    {
      icon: facebook,
      alt: `facebook`,
      size: isMobile ? '22px' : '25px',
      url: `https://www.facebook.com/profile.php?id=61573032104589`
    },
    {
      icon: x,
      alt: `x`,
      size: isMobile ? '21px' : '24px',
      url: `https://x.com/nextfour_ai`
    },
    {
      icon: youtube,
      alt: `youtube`,
      size: isMobile ? '24px' : '27px',
      url: `https://www.youtube.com/@nextfourai`
    },
    {
      icon: tiktok,
      alt: `tiktok`,
      size: isMobile ? '20px' : '23px',
      url: `https://www.tiktok.com/@nextfour.ai`
    }
  ]
  const socials = <div className="dca-footer-socials-wrapper">
    {socialsList.map((social, index) =>
      <img
        key={index}
        style={{
          height: `${social.size}`,
          width: `${social.size}`,
          cursor: 'pointer'
        }}
        className="dca-footer-social-icon"
        id={index < socialsList.length - 1 ? `dca-footer-social-icon-margin` : ''}
        src={social.icon}
        alt={social.alt}
        onClick={() => window.open(social.url, "_blank", "noopener,noreferrer")}></img>)}
  </div>

  return (
    <div className="dca-footer-wrapper">

      <div className="dca-footer-links-wrapper">
        {window.innerWidth > 768 ? <Fragment>
          {toolsResourcesOne}

          {toolsResourcesTwo}
        </Fragment> : toolsResourcesMobile}

        {company}
      </div>

      {socials}

      <div className="dca-footer-copyright">{new Date().getFullYear()} &copy; NEXTFOUR.AI</div>

      {location.pathname == pageRoutes.home && <span className="dca-footer-branding">NEXTFOUR.AI</span>}
    </div>
  )
}

export { Footer }